"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _formsModule = _interopRequireDefault(require("@albelli/arc-3/lib/forms.module.css"));
var _dropdownModule = _interopRequireDefault(require("@albelli/arc-3/lib/dropdown.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RadioOption = _ref => {
  let {
    value,
    checked,
    children,
    onChange
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("li", {
    onClick: () => {
      onChange(value);
    }
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("input", {
    type: "radio",
    name: "format",
    "data-value": value,
    checked: checked
  }), " ", /*#__PURE__*/_react.default.createElement("span", null, children)));
};
const RadioDropdown = _ref2 => {
  let {
    onChange,
    label,
    isRequired,
    id,
    className,
    borderless,
    error,
    disabled,
    compact,
    allValues,
    selectedValue,
    ...props
  } = _ref2;
  const [selecting, setSelecting] = (0, _react.useState)(false);
  const selected = allValues.find(x => x.value == selectedValue);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    "data-cy": "arc3-radio-dropdown"
  }, !!label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: _formsModule.default["arc3-form-label"]
  }, label, isRequired ? " *" : null), /*#__PURE__*/_react.default.createElement("ul", _extends({
    className: (0, _classnames.default)(_dropdownModule.default["arc3-dropdown"], _dropdownModule.default["dropdown--filter"], {
      [_dropdownModule.default["--no-border"]]: borderless,
      [_dropdownModule.default["error"]]: error,
      [_dropdownModule.default["disabled"]]: disabled,
      [_dropdownModule.default["open"]]: selecting,
      ["arc3-full-width"]: !compact
    })
  }, props), /*#__PURE__*/_react.default.createElement("li", {
    className: _dropdownModule.default["arc3-dropdown__initial-select"],
    onClick: () => setSelecting(!disabled && !selecting)
  }, /*#__PURE__*/_react.default.createElement("span", null, selected === null || selected === void 0 ? void 0 : selected.description)), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: "arrow_right",
    size: "extra-small",
    className: _dropdownModule.default["arc3-dropdown__icon"]
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_dropdownModule.default["arc3-dropdown__itemswrapper"], {
      ["arc3-full-width"]: !compact,
      ["arc3-hide"]: !selecting
    })
  }, allValues.map(item => {
    return /*#__PURE__*/_react.default.createElement(RadioOption, {
      value: item.value,
      checked: (selected === null || selected === void 0 ? void 0 : selected.value) == item.value,
      onChange: value => {
        setSelecting(!selecting);
        onChange(value);
      }
    }, item.description);
  }))), !!error && /*#__PURE__*/_react.default.createElement("small", {
    className: _dropdownModule.default["arc3-dropdown-message"]
  }, /*#__PURE__*/_react.default.createElement("span", null, error)));
};
exports.RadioDropdown = RadioDropdown;